import { Component, OnInit } from '@angular/core';
import { DownloadService } from 'src/app/services/download.service';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

    public logoFooter : string = 'logo-medipeps.png';
    public docMentionsLegales: string = 'Mentions_legales.pdf';
    public lienMentionsLegales: string = "FOOTER.LEGAL";
    public docCgu : string = 'Note_RGPD.pdf';
    public lienCgu : string = "FOOTER.CGU";
    public logoMipih : boolean = true;
    public lienCguPatient: string = "FOOTER.CGU-PATIENT";
    public docCguPatient: string = "CGU_Patient.pdf";

    constructor(public userService: UserService, private downloadService: DownloadService) {}

    ngOnInit(): void {

        if (this.userService.currentUser.template != null) {

            if (this.userService.currentUser.template.logoFooter != null) {
                this.logoFooter = this.userService.currentUser.template.logoFooter;
            }

            if (this.userService.currentUser.template.docMentionsLegales != null) {
                this.docMentionsLegales = this.userService.currentUser.template.docMentionsLegales;
            }

            if (this.userService.currentUser.template.lienMentionsLegales != null) {
                this.lienMentionsLegales = this.userService.currentUser.template.lienMentionsLegales;
            }

            if (this.userService.currentUser.template.docCgu != null) {
                this.docCgu = this.userService.currentUser.template.docCgu;
            }

            if (this.userService.currentUser.template.lienCgu != null) {
                this.lienCgu = this.userService.currentUser.template.lienCgu;
            }

            if (this.userService.currentUser.template.logoMipih != null) {
                this.logoMipih = this.userService.currentUser.template.logoMipih;
            }

            if (this.userService.currentUser.template.docCguPatient) {
                this.docCguPatient = this.userService.currentUser.template.docCguPatient;
            }

            if (this.userService.currentUser.template.lienCguPatient) {
                this.lienCguPatient = this.userService.currentUser.template.lienCguPatient;
            }

        }
    }

    downloadFile(fileName: string)
    {
        this.downloadService.downloadFile(fileName).subscribe(blob => {
            const a = document.createElement('a')
            const objectUrl = URL.createObjectURL(blob)
            a.href = objectUrl
            a.download = fileName;
            a.click();
            URL.revokeObjectURL(objectUrl);
        })
    }
}
